import { Hike, View } from "../../../../src/components/mdx-hiker";
import views from "../../../../posts/nextjs-static-props/views";
import * as React from 'react';
export default {
  Hike,
  View,
  views,
  React
};